import { FormTestContainer } from "../../../containers/borrowSystem/BorrowForm/FormTestContainer"

export function FormTestPage() {
    return (
        <FormTestContainer />
    )
}